var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYotpoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.1 76",
    enableBackground: "new 0 0 71.1 76",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2F84ED",
    cx: 36,
    cy: 38.3,
    rx: 33.1,
    ry: 34.1
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "17.5,25.1 21.4,25.1 24.4,30.6 27.3,25.1 31,25.1 26.1,33.9 26.1,38.6 22.5,38.6 22.5,34  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.9,31.9c0-4.1,3.3-6.9,7.1-6.9c3.8,0,7.1,2.9,7.1,6.9c0,4.1-3.3,7-7.1,7C33.2,38.8,29.9,36,29.9,31.9  M40.4,31.9c0-2.1-1.3-3.8-3.5-3.8c-2.2,0-3.5,1.7-3.5,3.8c0,2.1,1.3,3.8,3.5,3.8C39.2,35.7,40.4,34,40.4,31.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "47.4,28.1 43.9,28.1 43.9,25.1 54.5,25.1 54.5,28.1 51,28.1 51,38.6 47.4,38.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.1,53.4h-3.5V39.9h5c3.6,0,5.6,2.3,5.6,5.3c0,3-2,5.3-5.6,5.3h-1.5V53.4z M23.4,47.4 c1.6,0,2.2-0.9,2.2-2.2c0-1.3-0.6-2.3-2.2-2.3h-1.3v4.5H23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.8,46.7c0-4.1,3.3-6.9,7.1-6.9c3.8,0,7.1,2.9,7.1,6.9c0,4.1-3.3,7-7.1,7C33.1,53.6,29.8,50.8,29.8,46.7  M40.4,46.7c0-2.1-1.3-3.8-3.5-3.8c-2.2,0-3.5,1.7-3.5,3.8c0,2.1,1.3,3.8,3.5,3.8C39.1,50.5,40.4,48.8,40.4,46.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44,51.7c0-1.2,0.9-2,1.9-2c1,0,1.9,0.8,1.9,2c0,1.2-0.9,2-1.9,2C44.9,53.6,44,52.8,44,51.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYotpoIcon);
export default __webpack_public_path__ + "static/media/yotpo_icon.ed75ef8de6bc70596b1a3808df7cafe1.svg";
export { ForwardRef as ReactComponent };